export const getOverallRanking = (state) => state.ranking?.overallRanking;
export const getMyOverallRanking = (state) => state.ranking?.myRanking;
export const getRoundRanking = (state) => state.ranking?.roundRanking;
export const getMyWeeklyRanking = (state) => state.ranking?.myWeeklyRanking;
export const getWeeklyRankingLoading = (state) => state.ranking?.weeklyRankingLoading;
